import React from 'react';
import InfoTip from './InfoTip';

// KPI card con el estilo de la plantilla PROFLUX.
// Variantes: 'default' | 'ok' | 'danger'
const KpiCard = ({ icon, label, value, unit, sub, sub2, extra, status, showTag = true, info, className = '' }) => {
  const tone =
    status === 'ok'
      ? 'text-[#0E9F6E]'
      : status === 'danger'
      ? 'text-[#B71D3F]'
      : 'text-[#001F41] dark:text-white';
  const tag =
    status === 'ok'
      ? { bg: 'bg-[#E8F6F0]', text: 'text-[#0E9F6E]' }
      : status === 'danger'
      ? { bg: 'bg-[#FEECEF]', text: 'text-[#B71D3F]' }
      : { bg: 'bg-[#F3F3F3]', text: 'text-[#43474F]' };

  return (
    <div className={`relative overflow-hidden bg-white dark:bg-gray-800 rounded-xl border border-gray-200/80 dark:border-gray-700/80 shadow-sm p-5 ${className}`}>
      {showTag && status && status !== 'default' && (
        <span
          className={`absolute top-4 right-5 text-[10px] font-bold tracking-wider px-2.5 py-1 rounded-full ${tag.bg} ${tag.text}`}
        >
          {status === 'ok' ? 'CONCILIADO' : status === 'danger' ? 'REVISAR' : ''}
        </span>
      )}
      <div className="flex items-center gap-2 mb-3.5">
        {icon && (
          <div className="w-[26px] h-[26px] rounded-md flex items-center justify-center text-[13px] bg-[#E7EEF7] dark:bg-[#1a2a3f]">
            {icon}
          </div>
        )}
        <div className="text-[11px] font-semibold tracking-wider text-[#43474F] dark:text-gray-400 uppercase">
          {label}
        </div>
        {info && <InfoTip>{info}</InfoTip>}
      </div>
      <div className="flex items-baseline">
        <span className={`text-[34px] font-extrabold tracking-tight leading-none ${tone}`}>{value}</span>
        {unit && <span className="text-sm font-semibold text-[#43474F] dark:text-gray-400 ml-1.5">{unit}</span>}
      </div>
      {sub && (
        <div className="mt-3 pt-2.5 border-t border-[#EEEEEE] dark:border-gray-700 flex items-baseline justify-between">
          <span className="text-[11.5px] text-[#43474F] dark:text-gray-400">{sub.label}</span>
          <b className={`text-[15px] font-bold ${status === 'danger' ? 'text-[#B71D3F]' : 'text-[#1A1C1C] dark:text-white'}`}>
            {sub.value}
          </b>
        </div>
      )}
      {sub2 && (
        <div className="mt-2 flex items-baseline justify-between">
          <span className="text-[11.5px] text-[#43474F] dark:text-gray-400">{sub2.label}</span>
          <b className="text-[13.5px] font-semibold text-[#0F3460] dark:text-gray-200">{sub2.value}</b>
        </div>
      )}
      {extra}
    </div>
  );
};

export default KpiCard;
